import React from "react";
import {
    ShieldCheck,
    Zap,
    Code2,
} from "lucide-react";

import { connectPetpooja } from "../services/petpooja";

export function SetupPetpooja() {

    async function handleConnect() {

        try {

            const outletUid =
                localStorage.getItem("selectedOutletUid");

            if (!outletUid) {

                alert("Please select an outlet first.");

                return;

            }

            await connectPetpooja(outletUid);

            alert(
                "Petpooja integration request submitted successfully."
            );

        } catch (error) {

            console.error(
                "Failed to connect Petpooja:",
                error
            );

            alert(
                error.response?.data?.error ||
                "Failed to connect Petpooja."
            );

        }

    }

    const features = [

        {
            icon: <ShieldCheck size={20} />,
            text: "Secure integration",
        },

        {
            icon: <Zap size={20} />,
            text: "Takes 1-2 days",
        },

        {
            icon: <Code2 size={20} />,
            text: "No coding required",
        },

    ];

    return (

        <>

            <header className="setup-header">

                <div className="setup-header-logo">

                    <img
                        src={require("./../imgs/nextgo-logo.png")}
                        alt="NextGo Logo"
                        className="setup-header-logo-icon"
                    />

                    <span className="setup-header-logo-text">
                        Next<span className="blue">Go</span>
                    </span>

                </div>

            </header>

            <main className="integration-setup-page">

                <div className="integration-setup-container">

                    <div className="integration-setup-card">

                        <div className="integration-logo-wrapper">

                            <img

                                src="https://firebasestorage.googleapis.com/v0/b/loyaltea-46e52.firebasestorage.app/o/assets%2Fpetpooja-small-logo.png?alt=media&token=8bbef549-7ec2-4476-864a-5ef6aa44d367"

                                alt="Petpooja"

                                className="integration-logo"

                            />

                        </div>

                        <h1>

                            Connect your Petpooja Account

                        </h1>

                        <p className="integration-subtitle">

                            Integrate your Petpooja POS system to record
                            transactions, sync customer data, and manage
                            offers seamlessly.

                        </p>

                        <div className="integration-benefits">

                            {

                                features.map((feature) => (

                                    <div

                                        key={feature.text}

                                        className="integration-benefit"

                                    >

                                        <div className="integration-benefit-icon">

                                            {feature.icon}

                                        </div>

                                        <span>

                                            {feature.text}

                                        </span>

                                    </div>

                                ))

                            }

                        </div>

                        <button

                            className="primary-btn integration-connect-btn"

                            onClick={handleConnect}

                        >

                            Connect Petpooja

                        </button>

                    </div>

                </div>

            </main>

        </>

    );

}